import { Component } from '@angular/core';

@Component({
  selector: 'app-content-loader',
  templateUrl: './content-loader.component.html'
})
export class ContentLoaderComponent {

}
